

function Footer(){
    return(<div>
        Desde el footer
    </div>)

}

export default Footer;